import { render, staticRenderFns } from "./GiftCardModal.vue?vue&type=template&id=0003ce10&scoped=true"
import script from "./GiftCardModal.vue?vue&type=script&lang=js"
export * from "./GiftCardModal.vue?vue&type=script&lang=js"
import style0 from "./GiftCardModal.vue?vue&type=style&index=0&id=0003ce10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003ce10",
  null
  
)

export default component.exports